import { services } from '../../../mocks/bbenergy';

const trading = services[0];

export default function ServicesSection() {
  return (
    <div id="services" className="bg-[#f5f7fa]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-[#d4571a] text-xs font-bold tracking-widest mb-3">OUR BUSINESS</p>
            <h3 className="text-[#0c1f38] text-3xl font-bold mb-5">{trading.title}</h3>
            <p className="text-gray-600 text-base leading-relaxed">{trading.description}</p>
          </div>
          <div className="w-full h-64 lg:h-80">
            <img
              src={trading.image}
              alt={trading.title}
              className="w-full h-full object-cover object-top rounded-lg"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
